const tippyProps = {
  theme: "tooltip",
  animation: "tooltip",
  arrow: false,
  touch: false,
  appendTo: () => document.querySelector('#root')
}

export default tippyProps;
